<template>
    <div class="page-container">
        <el-card class="page-content" shadow="never">
            <div class="title">代币券数据统计</div>

            <filters :filters="filters" :export-loading="exportLoading" @search="search" @reset="reset"
                @export="download('代币券数据统计')" />

            <el-table :data="rows" size="mini" v-loading="loading" height="calc(100vh - 300px)">
                <el-table-column prop="userUid" label="用户UID" min-width="110" />
                <el-table-column prop="userTypeDesc" label="用户类型" min-width="100" />
                <el-table-column label="合伙人UID" min-width="110">
                    <template slot-scope="s">
                        {{ display(s.row.partnerUid) }}
                    </template>
                </el-table-column>
                <el-table-column prop="couponNo" label="卡券ID" min-width="180" />
                <el-table-column label="卡券领取金额" min-width="140">
                    <template slot-scope="s">
                        {{ display(s.row.receiveAmount) }}
                    </template>
                </el-table-column>
                <el-table-column prop="coin" label="币种" min-width="90" />
                <el-table-column label="使用时间" min-width="170">
                    <template slot-scope="s">
                        {{ time(s.row.useTime) }}
                    </template>
                </el-table-column>
            </el-table>

            <div class="pag">
                <pagination :size="pagination.size" :total="total" :page="pagination.page" @pageChanged="pageChanged" />
            </div>
        </el-card>
    </div>
</template>

<script>
import Pagination from 'components/pagination'
import Filters from './Filters'
import mixin from './mixin'

export default {
    name: 'WelfareTokenStatistic',
    components: { Pagination, Filters },
    mixins: [mixin],
    data: () => ({
        kind: 'token',
    }),
    created() {
        this.fetchAll()
    },
    methods: {
        fetchAll() {
            this.fetchList()
        },
    },
}
</script>

<style lang="less" scoped>
.title {
    margin-bottom: 18px;
    color: #409eff;
    font-size: 16px;
}

.pag {
    display: flex;
    justify-content: center;
}
</style>
